import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FirebaseService } from 'src/app/service/firebase.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {

  @Input() group: string;
  @Input() device: string;
  @ViewChild('form') form;

  formConfig: any = [];
  constructor(private firebaseService: FirebaseService) { }

  ngOnInit() {
    this.firebaseService.getModuleFromDevice('form', this.group, this.device).then(data => {
      if (data != undefined)
        this.formConfig = data.data.data;
    }).catch(err => {
      console.log(err);
      })

  }



  addInput(type, required) {
    let item = { type: type, label: '' ,required: false }

    this.formConfig.push(item)
  }

  removeElement(elem, i) {

   // console.log(elem)

   /* this.formConfig.forEach((item, index, object) => {
        if (item === elem) {
          object.splice(index, 1);
        }
    })*/
  }

  submit(form) {
    this.firebaseService.setModuleFromDevice('form', this.group, this.device, { data: this.formConfig })

  }

}
